<template>
    <div class="clearfix">
        <div class="modal_content p-20">
            <div class="alert alert_default t_center">
                <strong>{{ $t('heads_up') }}! </strong>{{ $t('_incoming.header_attention') }}:
            </div>
            <div class="row">
                <div class="col-sm-offset-1 col-sm-2">
                    <div class="infographic">
                        <div class="clearfix">
                            <span class="circle">1</span>
                        </div>
                        <div class="clearfix">
                            {{ $t('allowed_files_extension') }}: <strong class="text-danger">.xls, xlsx</strong>
                        </div>
                        <i class="fa fa-file-excel-o icons_effect"></i>
                    </div>
                </div>
                <div class="col-sm-2 t_center">
                    <i class="icons_import ion-forward rotate_17"></i>
                </div>
                <div class="col-sm-3">
                    <div class="infographic" @mouseleave="onHover()" @mouseenter="onHover('stepOne')">
                        <div class="clearfix">
                            <span class="circle">2</span>
                        </div>
                        {{ $t('_incoming.step2') }}
                    </div>
                </div>
                <div class="col-sm-offset-1 col-sm-3">
                    <i class="icons_import ion-forward rotate_80 m-t-30"></i>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7">
                    <table class="table_import_deals">
                        <thead>
                        <tr>
                            <th class="w_50"></th>
                            <th>A</th>
                            <th>B</th>
                            <th>C</th>
                            <th>D</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :class="{'first_line': elHover == 'stepOne' , 'second_line': elHover == 'stepTwo' , 'all_rows': elHover == 'stepThree'}">
                            <td>1</td>
                            <td>{{ $t('first_name') }}</td>
                            <td>{{ $t('last_name') }}</td>
                            <td>{{ $t('email') }}</td>
                            <td>{{ $t('phone') }}</td>
                        </tr>
                        <tr :class="{'all_rows': elHover == 'stepThree'}">
                            <td>2</td>
                            <td>John</td>
                            <td>Deo</td>
                            <td>john@deo.com</td>
                            <td>12345678</td>
                        </tr>
                        <tr :class="{'all_rows': elHover == 'stepThree'}">
                            <td>3</td>
                            <td>Smith</td>
                            <td>Henry</td>
                            <td>smith@henry.ie</td>
                            <td>87654321</td>
                        </tr>
                        <tr :class="{'all_rows': elHover == 'stepThree'}">
                            <td>4</td>
                            <td>Adam</td>
                            <td>Jansen</td>
                            <td>adam@jansen.br</td>
                            <td>(12) 345678</td>
                        </tr>
                        <tr :class="{'all_rows': elHover == 'stepThree'}">
                            <td>5</td>
                            <td>Joe</td>
                            <td>Walter</td>
                            <td>joe@walter.com</td>
                            <td>+12 345678</td>
                        </tr>
                        </tbody>
                    </table>
                    <small class="help_import_deal">{{ $t('example_sheet') }}</small>
                </div>
                <div class="col-sm-offset-1 col-sm-3">
                    <div class="infographic m-t-40" @mouseleave="onHover()" @mouseenter="onHover('stepTwo')">
                        <div class="clearfix">
                            <span class="circle">3</span>
                        </div>
                        {{ $t('_incoming.step3') }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-offset-1 col-sm-2">
                    <div class="infographic step_05" @mouseleave="onHover()" @mouseenter="onHover('stepFive')">
                        <div class="clearfix">
                            <span class="circle">5</span>
                        </div>
                        <div class="clearfix">
                            {{ $t('_incoming.step5') }}
                        </div>
                        <i class="fa fa-upload icons_effect"></i>
                    </div>
                </div>
                <div class="col-sm-3 t_center">
                    <i class="icons_import ion-forward rotate_190 m-t-20"></i>
                </div>
                <div class="col-sm-3">
                    <div class="infographic" @mouseleave="onHover()" @mouseenter="onHover('stepThree')">
                        <div class="clearfix">
                            <span class="circle">4</span>
                        </div>
                        {{ $t('_incoming.step4') }}
                    </div>
                </div>
                <div class="col-sm-3">
                    <i class="icons_import ion-forward rotate_160"></i>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <a href="/static/files/example-lead-import.xls" download class="btn btn-purple"><span class="btn-label"><i class="wi wi-cloud-down"></i></span>{{ $t('example_sheet') }}</a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-offset-3 col-sm-6" :class="{'has-error': errors['name']}">
                    <div class="fileupload show border_upfile waves-light" :class="{'has-error': errors['file'], 'active': elHover == 'stepFive'}">
                        <span><i class="wi wi-cloud-up m-r-5"></i>{{ $t('drop_file_or_click_to_upload') }}</span>
                        <input @change="feedFile" type="file" ref="inputFile" class="upload" accept=".xls, .xlsx">
                        <div v-if="fileName">
                            <i class="fa fa-close icon_close" @click.prevent="clearFileField()"></i>
                            <i class="fa fa-file-excel-o" style="color: #5fbeaa;"></i>
                            {{ fileName }}
                        </div>
                    </div>
                    <span class="error" v-if="errors['file']">{{(typeof errors['file'] === 'string') ? errors['file'] : errors['file'][0] }}</span>
                </div>
            </div>
        </div>
        <div class="p-20 p-t-0 clearfix">
            <span class="btn btn-white pull-left" @click="goBack()">{{ $t('cancel') }}</span>
            <span class="btn btn-default pull-right" @click.prevent="sendFile()" v-pml-block="isUploading">{{ $t('send_file') }}</span>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import { uploadFile } from 'services/incoming'

    export default {
        name: 'IncomingUploadFile',
        data () {
            return {
                isUploading: false,
                fileName: '',
                file: '',
                elHover: null,
                errors: []
            }
        },
        methods: {
            sendFile () {
                this.isUploading = true
                this.errors = []

                let data = new window.FormData()
                data.append('file', this.file)

                uploadFile(data)
                    .then((response) => {
                        if (response.data !== null && typeof response.data === 'object') {
                            this.$router.push({ name: 'incoming.import.cross-data' })
                            setTimeout(() => { bus.$emit('crossDataIncoming', response.data) }, 1000)
                        }
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isUploading = false })
            },
            feedFile (e) {
                e.preventDefault()

                var files = e.target.files

                if (typeof files[0] !== 'undefined') {
                    this.fileName = files[0].name
                    this.file = files[0]
                } else {
                    this.clearFileField()
                }
            },
            clearFileField () {
                this.fileName = ''
                this.file = ''
                this.errors = []
                this.$refs.inputFile.value = ''
            },
            onHover (value = null) {
                this.elHover = value
            },
            goBack () {
                bus.$emit('goBack')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/import/UploadFile.vue